import { AnnouncementsContainer } from './AnnouncementsContainer';

const name = 'AnnouncementsContainer';

export { AnnouncementsContainer, name };
